// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-G":"G_sp-175w-G___gy_M"};